import React from 'react';
import { Trans } from 'react-i18next';

import CommentsListComponent from './CommentsListComponent';

import { Text } from '../../common';

import {
  Nav,
  NavBtn,
  Total
} from './AdminManagmentCommentsS';
import RatingsListComponent from "./RatingListComponent";

export const REVIEW_TYPE = {
  ALL: 'all',
  COMMENTS: 'justComment',
  RESPONSE: 'withAnswer',
  RATING: 'rating'
};

const REVIEW_TYPES = [
  { type: REVIEW_TYPE.ALL, textKey: 'adminPanel.comments.navigationButtons.all' },
  { type: REVIEW_TYPE.COMMENTS, textKey: 'adminPanel.comments.navigationButtons.comments', countKey: 'unhandledCommentsCount' },
  { type: REVIEW_TYPE.RESPONSE, textKey: 'adminPanel.comments.navigationButtons.responses', countKey: 'unhandledAnswersCount' },
  { type: REVIEW_TYPE.RATING, textKey: 'adminPanel.comments.navigationButtons.rating', countKey: 'unhandledRatingsCount' }
];

const AdminManagementCommentsComponent = ({
  commentsStateType,
  setCommentsStateType,
  totalCommentsCount,
  totalRatingsCount,
  hasMoreComments,
  hasMoreRatings,
  comments,
  ratings,
  setPage,
  page,
  ...rest
}) =>  {
  const onLoadMore = () => setPage(++page);
  return (
    <>
      <Nav>
        {REVIEW_TYPES.map(({ type, textKey, countKey }) => (
          <NavBtn
            key={type}
            padding="5px 15px"
            fz="mediumText"
            fontFamily="normal"
            onClick={() => setCommentsStateType(type)}
            active={type === commentsStateType}
          >
            <Trans i18nKey={textKey} /> { countKey && rest[countKey] !== 0 && `(${rest[countKey]})` }
          </NavBtn>
        ))}
      </Nav>

      {
        commentsStateType === REVIEW_TYPE.RATING
        ? <RatingsListComponent { ...{ ratings, onLoadMore, hasMoreRatings }} />
        : <CommentsListComponent {...{ comments, onLoadMore, hasMoreComments }} />
      }

      <Total>
        <Text size="bigText"><Trans i18nKey="adminPanel.comments.totalComments"/>: </Text>
        <Text color="red">{commentsStateType === REVIEW_TYPE.RATING ? totalRatingsCount : totalCommentsCount}</Text>
      </Total>
    </>
  )
};

export default AdminManagementCommentsComponent;
